import React from 'react'

import { Box } from 'components/_new/layout'


type MainSectionProps = {
  id?: string
  className?: string
  alignCenter?: boolean
  withPaddingTop?: boolean
  withPaddingBottom?: boolean
}

const MainSection: React.FunctionComponent<MainSectionProps> = (props) => {
  const { children, id, className, alignCenter, withPaddingTop = true, withPaddingBottom = true } = props

  return (
    <Box
      id={id}
      className={className}
      alignCenter={alignCenter}
      pt={withPaddingTop ? 36 : null}
      pb={withPaddingBottom ? 36 : null}
    >
      {children}
    </Box>
  )
}


export default MainSection
